<template>
  <div  class="right-sidebar right_side_star">
    <div class="right-sidebar-wrap active">
      <!-- Left Sidebar Header -->
      <div class="left-chat-title d-flex justify-content-between align-items-center border-bottom-0">
        <div class="fav-title mb-0">
          <h6>
            <a href="#"
               class="remove-star-message d-flex"
               @click.prevent="onClose"
            >
              <i class="bx bx-arrow-back me-2"></i>
            </a>

            <slot name="title"></slot>
          </h6>
        </div>

        <div class="star-drop">
          <slot name="actions"></slot>
        </div>
      </div>
      <!-- /Left Sidebar Header -->

      <div class="scroll-area overflow-y-auto">
        <div class="sidebar-body chat h-auto star-chat-group">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },

  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
    };
  },

  methods: {
    scrollHandle(evt) {
      //
    },

    onClose() {
      this.$emit('close');
    }
  },
};
</script>
